import jwt from 'jsonwebtoken'
import { isPF, token } from '../../api/auth/auth'
import { getAddressList } from '../../hooks/address/useAddresses'

const tokenDecoded = jwt.decode(token())

export const isInscricaoEstadualIsento = () => {
  if (tokenDecoded.tipoCliente === 'J') {
    return tokenDecoded.inscricaoEstadual === 'ISENTO'
  } else {
    return null
  }
}

export const getInscricaoEstadualCode = () => {
  if (tokenDecoded.tipoCliente === 'J') {
    return tokenDecoded.inscricaoEstadual
  }
}

export const getFaturamentoUF = async (addressList) => {

  if (!addressList)
    addressList = await getAddressList();
  if (!isPF() && addressList[0]?.apelido !== 'Faturamento') {
    return addressList[0]?.uf
  } else {
    return addressList?.filter((item) => item.apelido === 'Faturamento')[0]?.uf
  }
}

export const isMaxAdressLimit = (userAddress) => {
  if (userAddress.length >= 5) {
    return true
  }
}

export const allowAddEnderecoEntregaPJ = (faturamentoUF) => {
  if (
    !isInscricaoEstadualIsento() &&
    (faturamentoUF === 'SP' || faturamentoUF === 'RJ')
  ) {
    // console.log('permitir Adicionar')
    return true
  } else if (
    !isInscricaoEstadualIsento() &&
    (faturamentoUF !== 'SP' || faturamentoUF !== 'RJ')
  ) {
    // console.log('bloquer Adicionar')
    return false
  } else {
    // console.log('permitir Adicionar')
    return true
  }
}
